import {Button} from '@/components/ui/button';
import {Row} from '@tanstack/react-table';
import {DotsHorizontalIcon} from "@radix-ui/react-icons";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";

interface DataTableRowActionsProps<TData> {
    row: Row<TData>;
    onEdit?: (value: TData) => void;
    onDelete?: (value: TData) => void;
    viewProfileUrl?: string;
    viewMentorshipGroupUrl?: string;
    viewPreferenceUrl?: string;
}

const DataTableRowActions = <TData, >({
                                          row,
                                          onEdit,
                                          onDelete,
                                          viewProfileUrl,
                                          viewMentorshipGroupUrl,
                                          viewPreferenceUrl,
                                      }: DataTableRowActionsProps<TData>) => {
    const {t} = useTranslation();

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" className="flex h-8 w-8 p-0 data-[state=open]:bg-muted">
                    <DotsHorizontalIcon className="h-4 w-4"/>
                    <span className="sr-only">Open menu</span>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-[200px]">
                {viewProfileUrl &&
                    <DropdownMenuItem asChild>
                        <Link to={viewProfileUrl}>{t("common.admin.viewProfile")}</Link>
                    </DropdownMenuItem>
                }
                {viewMentorshipGroupUrl &&
                    <DropdownMenuItem asChild>
                        <Link to={viewMentorshipGroupUrl}>{t("common.admin.viewMentorshipGroup")}</Link>
                    </DropdownMenuItem>
                }
                {viewPreferenceUrl &&
                    <DropdownMenuItem asChild>
                        <Link to={viewPreferenceUrl}>{t("common.admin.viewPreference")}</Link>
                    </DropdownMenuItem>
                }
                {onEdit &&
                    <DropdownMenuItem onClick={() => onEdit(row.original)}>{t("common.edit")}</DropdownMenuItem>
                }
                {onDelete && <>
                    <DropdownMenuSeparator/>
                    <DropdownMenuItem onClick={() => onDelete(row.original)}>{t("common.delete")}</DropdownMenuItem>
                </>}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default DataTableRowActions;